import PropTypes from 'prop-types'

import LocationMarkerIcon from 'images/icons/location-marker.svg'
import PhoneCallIcon from 'images/icons/phone-call.svg'
import InboundCallIcon from 'images/icons/inbound-call.svg'
import OutboundCallIcon from 'images/icons/outbound-call.svg'
import GoogleMeetLogo from 'images/logos/google-meet.svg'
import ZoomLogo from 'images/logos/zoom.svg'
import MsTeamsLogo from 'images/logos/ms-teams.svg'
import WebexLogo from 'images/logos/webex.svg'
import GotomeetingLogo from 'images/logos/gotomeeting.svg'
import AskInviteIcon from 'images/icons/ask-invitee-location.svg'
import CustomLocationIcon from 'images/icons/custom-location.svg'

const ICONS_FOR_KIND = {
  physical: LocationMarkerIcon,
  inbound_call: PhoneCallIcon,
  outbound_call: PhoneCallIcon,
  google_conference: GoogleMeetLogo,
  zoom_conference: ZoomLogo,
  microsoft_teams_conference: MsTeamsLogo,
  webex_conference: WebexLogo,
  gotomeeting_conference: GotomeetingLogo,
  custom: CustomLocationIcon,
  ask_invitee: AskInviteIcon
}

const ICONS_FOR_ONE_OFF_KIND = {
  ...ICONS_FOR_KIND,
  inbound_call: InboundCallIcon,
  outbound_call: OutboundCallIcon
}

const IconComponent = ({ Icon, ...props }) => (
  typeof Icon === 'string'
    ? <img src={Icon} alt="" {...props} />
    : <Icon {...props} />
)

export const LocationIcon = ({ kind, isOneOff = false, ...props }) => (
  isOneOff
    ? <IconComponent Icon={ICONS_FOR_ONE_OFF_KIND[kind]} {...props} />
    : <IconComponent Icon={ICONS_FOR_KIND[kind]} {...props} />
)

LocationIcon.propTypes = {
  kind: PropTypes.string.isRequired,
  isOneOff: PropTypes.bool
}
